import { render, staticRenderFns } from "./ServiceReportBtn.vue?vue&type=template&id=24d2a5ce&"
import script from "./ServiceReportBtn.vue?vue&type=script&lang=js&"
export * from "./ServiceReportBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports